const Switch = {
  baseStyle: {
    track: {
      bg: "gray.200",
      _checked: {
        bg: "blue.500"
      }
    },
    thumb: {
      bg: "white",
      _checked: {
        bg: "gray.900"
      }
    }
  }
};

export default Switch;
